export const habaAddress = {
  habaAddressForm: {
    heading: 'Where are we going?',
    section: {
      billingAddress: 'Billing Address',
      shippingAddress: 'Delivery Address',
      address: 'Address',
      title: 'Title',
    },
    useThisShippingAddress: 'Ship to this address',
    useThisBillingAddress: 'Use as billing address',
    personalData: 'What are your personal details?',
    newAddressHeadline: 'Add new address',
    newAddressButton: 'Add address',
    editNewAddressHeadline: 'Edit address',
    saveAddress: 'Save address',
    submitChanges: 'Save changes',
    billingAddressRequired: 'You must select a billing address',
    deliveryAddressRequired: 'You must select a delivery address',
    deliveryAddressCountryMismatch:
      'The selected delivery address does not belong to this shop. Please select a delivery address in this country or add a new one.',
    editDeliveryAddress: 'Edit delivery address',
    editBillingAddress: 'Edit billing address',
    editDeliveryMethod: 'Edit shipping method',
    editPaymentMethod: 'Edit payment method',
    editEmailAddress: 'Edit email address',
    form: {
      privateCompanyToggle: {
        private: 'Private customer',
        company: 'Business customer',
      },
      firm: 'Company',
      title: {
        label: 'Title*',
        error: 'Please select title',
      },
      firstName: {
        label: 'First name*',
        error: 'Please enter first name',
      },
      lastName: {
        label: 'Last name*',
        error: 'Please enter last name',
      },
      name: {
        label: 'Name*',
        error: 'Please enter name',
      },
      year: {
        label: 'Year',
        labelRequired: 'Year*',
        error: 'Please enter year',
      },
      month: {
        label: 'Month',
        labelRequired: 'Month*',
        error: 'Please enter month',
      },
      day: {
        label: 'Day',
        labelRequired: 'Day*',
        error: 'Please enter day',
      },
      companyName: {
        label: 'Company*',
        error: 'Please enter company',
      },
      address1: {
        label: 'Street*',
        error: 'Please enter street',
      },
      nr: {
        label: 'No.*',
        error: 'Please enter number',
      },
      address2: {
        label: 'Additional address (optional)',
      },
      country: {
        label: 'Country*',
        error: 'Please select country',
      },
      city: {
        label: 'City*',
        error: 'Please enter city',
      },
      zipCode: {
        label: 'Postal code*',
        errorRequired: 'Please enter a postal code.',
        errorDefault: 'Please check if the format of the entered postal code is correct.',
        pattern: {
          errorMainText: 'Please check if the entered postal code is correct. Format: ',
          // following the zip code example patterns (that are shown after "errorMainText")
          '^[0-9]{3}$': '123',
          '^[0-9]{4}$': '1234',
          '^[0-9]{5}$': '12345',
          '^AD[1-7]00$': 'AD100',
          '^(FO-)?[0-9]{3}$': 'FO-100',
          '^GX11 1AA$': 'GX11 1AA',
          '^[A-Za-z0-9]{3} [A-Za-z0-9]{4}$': 'A99 A9A9',
          '^MD-[0-9]{4}$': 'MD-9999',
          '^[A-Za-z]{2,3} [0-9]{4}$': 'AAA 9999',
          '^[0-9]{4} ?[A-Za-z]{2}$': '9999ZZ',
          '^[0-9]{2}-[0-9]{3}$': '99-999',
          '^[0-9]{4}-[0-9]{3}$': '9999-999',
          '^[0-9]{3}[ -]?[0-9]{2}$': '999 99',
          '^[0-9]{3} ?[0-9]{2}$': '999 99',
        },
      },
      lengthError: 'This field is a required field and must be between 1 and 255 characters',
      dayLengthError: 'invalid day',
      monthLengthError: 'invalid month',
      yearLengthError: 'invalid year',
      phone: {
        required: 'Please enter phone number',
        pattern: 'Not a valid phone number',
      },
    },
    billingAddress: {
      selectAddress: 'Select the address associated with your card or payment method.',
      sameWithShippingAddress: 'Same as delivery address',
    },
    selectDifferentDeliveryAddress: 'Select different delivery address',
    selectDifferentBillingAddress: 'Select different billing address',
    choose: 'Select',
    salesForPrivateMatters:
      'Sales are exclusively for private, non-commercial use by the customer.',
    birthdate: 'Date of birth',
    optinalInformation: 'Optional contact information',
    updateAccountButtonText: 'CHANGE & SAVE DATA',
    customerDetailsUpdatedSuccesfully: 'Your customer data has just been updated',
  },
  habaAddressMelissa: {
    heading: 'Address verification',
    paragraph:
      'Dear customer, unfortunately we do not recognize your address. Please check these address suggestions and confirm your address',
    suggestions: 'Did you perhaps mean:',
    yourInput: 'Your input:',
    submitButton: 'ACCEPT SELECTION & CONTINUE',
  },
};
